import { AsyncPageRender } from '@components/AsyncComponent';
import { ProtectedRoute } from '@components/Layout/ProtectedRoute';
import { pageModule } from '@components/pageModule';
import { Route } from '@packages/router';

export const routes$ = {
    // FactoryDashboard: AsyncPageRender(() => pageModule(import('../Factories/Dashboard/Orders'))),
    FactoryOrderView: AsyncPageRender(() => pageModule(import('../Factories/Orders/View'))),
    FactoryOrdersList: AsyncPageRender(() => pageModule(import('../Factories/Orders'))),
    FactoryListView: AsyncPageRender(() => pageModule(import('../Factories/List'))),
    FactoryProfile: AsyncPageRender(() => pageModule(import('../Factories/View'))),
    FactoryProducts: AsyncPageRender(() => pageModule(import('../Factories/Products'))),
    FactoryUsers: AsyncPageRender(() => pageModule(import('../Factories/Users'))),
};

function Router() {
    return (
        <>
            {/* <Route
                name={'Factories.Dashboard.Orders.List'}
                exact
                path={'/factories/dashboard/orders/:tab'}
                component={ProtectedRoute(routes$.FactoryDashboard)}
            /> */}
            <Route
                name={'Factories.Orders.View'}
                exact
                path={'/factories/order/:id/:tab?'}
                component={ProtectedRoute(routes$.FactoryOrderView)}
            />
            <Route
                name={'Factories.Orders.List'}
                exact
                path={'/factories/orders/:type/:tab?'}
                component={ProtectedRoute(routes$.FactoryOrdersList)}
            />
            <Route
                name={'Factories.List'}
                exact
                path={'/factories/list/'}
                component={ProtectedRoute(routes$.FactoryListView)}
            />
            <Route
                name={'Factories.Products'}
                exact
                path={'/factories/products'}
                component={ProtectedRoute(routes$.FactoryProducts)}
            />

            <Route
                name={'Factories.Users'}
                exact
                path={'/factories/users'}
                component={ProtectedRoute(routes$.FactoryUsers)}
            />
            <Route
                name={'Factories.ByFactory.View'}
                exact
                path={'/factories/:id/view/:tab'}
                component={ProtectedRoute(routes$.FactoryProfile)}
            />
        </>
    );
}

export default Router;
